import { createReducer, createNamespacer } from '../commons/js/utils/reducer';

const initialState = {
    error: "",
    modal: false,
    events: [],
    isLoading: false,
    currentPackage: '',
    currentSpoolCount: 0,
    currentProjectCode: '',
    currentProjectName: '',
    currentProjectRequiredDate: '',
    currentPackageCode: '',
    currentWeldInches: '',
    cutting: [],
    completedCuts: []
}

const namespacers = {
    calendar: createNamespacer("CALENDAR"),
}

const calendar = createReducer(initialState, {
    [namespacers.calendar("SET_EVENTS")]: (state, action) => {
        return {
            ...state,
            events: action.payload.value
        }
    },
    [namespacers.calendar("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.calendar("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.calendar("RESET_EVENTS")]: (state, action) => {
        return {
            ...state,
            events: initialState.events
        }
    },
    [namespacers.calendar("RESET_CALENDAR")]: (state, action) => {
        return {
            ...initialState
        }
    },
    [namespacers.calendar("SET_CUT_AND_COMPLETED_CUT_LIST")]: (state, action) => {
        return {
            ...state,
            cutting: action.payload.cutting,
            completedCuts: action.payload.completedCutting,
        }
    },
    [namespacers.calendar("TOGGLE_POPUP")]: (state, action) => {
        return {
            ...state,
            modal: !state.modal,
            currentPackage: action.payload.value.title,
            currentSpoolCount: action.payload.value.spoolCount,
            currentProjectCode: action.payload.value.projectCode,
            currentProjectName: action.payload.value.projectName,
            currentProjectRequiredDate: action.payload.value.end,
            currentPackageCode: action.payload.value.packageCode,
            currentWeldInches: action.payload.value.weldInches,
        }
    },
});

export default calendar;
